import {
  businessAppLogin,
  businessAppLoginAuto,
  userAppLogin,
  userAppLoginAuto,
} from "~/services/auth";
import { AppType } from "#/unique/domain";

export interface UnifiedLoginData {
  userType: AppType;
  snsType: string;
  hash: string;
  fcmToken?: string;
  cdMobileType?: string;
  email?: string;
}

export interface UnifiedLoginDataAuto {
  userType: AppType;
  hash: string;
  fcmToken?: string;
  cdMobileType?: string;
}

export interface UnifiedLoginResult {
  success: boolean;
  data?: any;
  error?: string;
  statusCode?: number;
}

export const unifiedLogin = async (
  loginData: UnifiedLoginData
): Promise<UnifiedLoginResult> => {
  // 필수 데이터 검증
  if (!loginData.userType || !loginData.snsType || !loginData.hash) {
    return {
      success: false,
      error: "필수 로그인 데이터가 누락되었습니다.",
      statusCode: 400,
    };
  }

  console.log("실행확인인", loginData.userType);
  console.log("실행확인인", loginData.snsType);
  console.log("실행확인인", loginData.hash);
  console.log("실행확인인", loginData.fcmToken);
  console.log("실행확인인", loginData.cdMobileType);
  console.log("실행확인인", loginData.email);
  try {
    // 비즈니스/고객 구분하여 기존 API 호출
    const response = await (loginData.userType === "business"
      ? businessAppLogin({
          cdSnsType: loginData.snsType,
          hash: loginData.hash,
          fcmToken: loginData.fcmToken || null,
          cdMobileType: loginData.cdMobileType || "ANDROID",
        })
      : userAppLogin({
          cdSnsType: loginData.snsType,
          hash: loginData.hash,
          fcmToken: loginData.fcmToken || null,
          cdMobileType: loginData.cdMobileType || "ANDROID",
        }));

    // 백엔드 응답의 statusCode 확인
    console.log("백엔드 응답:", response);
    console.log("백엔드 응답 statusCode:", response?.statusCode);

    if (response?.statusCode === 200) {
      console.log("로그인 성공 (statusCode: 200)");
      return {
        success: true,
        data: {
          ...response,
          hash: loginData.hash, // 해시값을 응답 데이터에 포함
        },
        statusCode: response.statusCode,
      };
    } else {
      console.log(
        "로그인 실패 또는 회원가입 필요 (statusCode:",
        response?.statusCode,
        ")"
      );
      // 201 (회원가입 필요) 또는 기타 상태 코드
      return {
        success: false,
        data: response,
        error: response?.message || "로그인에 실패했습니다.",
        statusCode: response?.statusCode,
      };
    }
  } catch (error: any) {
    console.error("통합 로그인 중 오류:", error);

    // 백엔드에서 반환한 에러 응답 처리
    if (error.response?.data?.statusCode) {
      return {
        success: false,
        error: error.response.data.message || "로그인에 실패했습니다.",
        statusCode: error.response.data.statusCode,
      };
    }

    return {
      success: false,
      error:
        error instanceof Error
          ? error.message
          : "알 수 없는 오류가 발생했습니다.",
      statusCode: 500,
    };
  }
};

export const unifiedLoginAuto = async (
  loginData: UnifiedLoginDataAuto
): Promise<UnifiedLoginResult> => {
  try {
    // 비즈니스/고객 구분하여 기존 API 호출
    const response = await (loginData.userType === "business"
      ? businessAppLoginAuto({
          hash: loginData.hash,
          fcmToken: loginData.fcmToken || null,
          cdMobileType: loginData.cdMobileType || null,
        })
      : userAppLoginAuto({
          hash: loginData.hash,
          fcmToken: loginData.fcmToken || null,
          cdMobileType: loginData.cdMobileType || null,
        }));

    // 백엔드 응답의 statusCode 확인
    console.log("백엔드 응답:", response);
    console.log("백엔드 응답 statusCode:", response?.statusCode);

    if (response?.statusCode === 200) {
      console.log("로그인 성공 (statusCode: 200)");
      return {
        success: true,
        data: {
          ...response,
          hash: loginData.hash, // 해시값을 응답 데이터에 포함
        },
        statusCode: response.statusCode,
      };
    } else {
      console.log(
        "로그인 실패 또는 회원가입 필요 (statusCode:",
        response?.statusCode,
        ")"
      );
      // 201 (회원가입 필요) 또는 기타 상태 코드
      return {
        success: false,
        data: response,
        error: response?.message || "로그인에 실패했습니다.",
        statusCode: response?.statusCode,
      };
    }
  } catch (error: any) {
    console.error("통합 로그인 중 오류:", error);

    // 백엔드에서 반환한 에러 응답 처리
    if (error.response?.data?.statusCode) {
      return {
        success: false,
        error: error.response.data.message || "로그인에 실패했습니다.",
        statusCode: error.response.data.statusCode,
      };
    }

    return {
      success: false,
      error:
        error instanceof Error
          ? error.message
          : "알 수 없는 오류가 발생했습니다.",
      statusCode: 500,
    };
  }
};
